
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2d1bb630&scoped=true!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LDTranscriptionsTab.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LDTranscriptionsTab.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2d1bb630!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LDTranscriptionsTab.vue"),
  /* scopeId */
  "data-v-2d1bb630",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/liveDiscussion/tabs/LDTranscriptionsTab.vue
// module id = 413
// module chunks = 61